import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useMutation } from '@tanstack/react-query'

type ChangeClaimOwnerPayload = {
  claimFormId: string
  backofficeUserId: string
}

const changeClaimOwner = async ({ claimFormId, backofficeUserId }: ChangeClaimOwnerPayload) => {
  const response = await httpClientPrivate.post(
    `${config.restUrl}/v1/backoffice/e-claim/${claimFormId}/change-owner`,
    { backofficeUserId },
  )

  return response.data
}

const useChangeClaimOwner = () => {
  const mutation = useMutation({
    mutationKey: ['useChangeClaimOwner'],
    mutationFn: async (payload: ChangeClaimOwnerPayload) => changeClaimOwner(payload),
  })

  return mutation
}

export { useChangeClaimOwner }
